<template>
  <span
    class="font-normal rounded"
    :class="[labelColor, isMyAccountButton ? 'text-xxs px-1 py-0.5' : 'px-2 py-1 text-xs']"
  >
    {{ categoryLabel }}
  </span>
</template>

<script lang="ts">

import type { DiscountCategory, MappedDiscount } from '~~/types/discounts';
import { DISCOUNT_CATEGORY } from '~~/types/discounts';

export default defineComponent({
  name: 'DiscountCategoryLabel',
  props: {
    category: {
      type: String as PropType<DiscountCategory>,
      required: true,
    },
    loyaltyLevel: {
      type: Object as PropType<MappedDiscount['loyaltyLevel']>,
      default: undefined,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    isMyAccountButton: {
      type: Boolean,
      default: false,
    },
    levelTitle: {
      type: String,
      default: '',
    },
  },
  setup(props) {

    const i18n = useI18n();

    const categoryLabel = computed<string>(() => {

      switch (props.category) {

        case DISCOUNT_CATEGORY.VOLUME:
          return i18n.t('Volume discount');
        case DISCOUNT_CATEGORY.LOYALTY:
          if (props.loyaltyLevel && props.levelTitle) {

            return `${i18n.t('Level')} ${props.loyaltyLevel.levelNumber} · ${props.levelTitle}`;

          }

          if (props.loyaltyLevel) {

            return `${i18n.t('expondo Partners')} - ${i18n.t('Level')} ${props.loyaltyLevel.levelNumber}`;
          
          } else {

            return i18n.t('expondo Partners');
          
          }
        case DISCOUNT_CATEGORY.PROMO_CODE:
          return i18n.t('Promo code');
        case DISCOUNT_CATEGORY.DISTINCT_PRODUCTS:
          return i18n.t('Multi-product discount');
        default:
          return i18n.t('Discount');
      
      }
    
    });

    const labelColor = computed(() => {

      if (props.isMyAccountButton) {

        return 'bg-EXPONDO-secondary-light text-EXPONDO-primary';
      
      }

      if (props.category === DISCOUNT_CATEGORY.LOYALTY) {

        return 'bg-EXPONDO-secondary text-white';
      
      }

      if (props.isActive) {

        return 'bg-EXPONDO-green-light';
      
      } else {

        return 'bg-EXPONDO-grey-10';
      
      }
    
    });

    return {
      categoryLabel,
      labelColor,
    };
  
  },
});

</script>
